import React, { Component } from "react";
import { Form, Select, Input, Button, Radio, Spin, Tree, Row, Col } from "antd";
import PropTypes, { string } from "prop-types";
import command from "../notice/command";
import { api, app } from "../../app";

const Option = Select.Option;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const TreeNode = Tree.TreeNode;

/**
 * 检查字段
 * @param target
 * @param prompt
 */
function checkField(target, prompt) {
  if (!target) {
    // console.log('target: ' + target)
    app.alert(prompt, "warn", "50%");
    return false;
  }
  return true;
}

class ChangeTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panel_tab: 1,
      selectDuiyuanIndexnoData: [], // 选中的队员indexno数据
      selectDuiyuanNameData: [], // 选中的队员名字数据
      selectActionDuiwuName: "", // 转出or加入的队伍名称
      action1: "1", // 转出or加入
      provinceList: [],
      teamList: [],
      playerList: [],
      all_team: [],
      reqParams: {},
      duiyuanColloct: "",
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.teamData();
    this.provinceData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 转入or加入的队伍列表
   **/
  teamData = () => {
    this.setData({ team_loading: true }, async () => {
      const params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
      let { flag, data, msg } = await app.post(api.TeamAll, params);
      if (flag !== 1) {
        app.alert(msg, "error");
        data = [];
      }
      this.setData({ team_loading: false, all_team: data, teamList: data });
    });
  };

  /**
   * 省份列表
   **/
  provinceData = () => {
    this.setData(async () => {
      const provinceList = await command.provinceData();
      this.setData({
        provinceList,
        loading: false,
        selectDuiyuanIndexnoData: [],
        selectDuiyuanNameData: [],
      });
    });
  };

  // 数组去重
  isRepeat = (arr) => {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] == arr[j]) {
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  };

  // 选择转出or加入队伍
  setCurrent_teamno = (e) => {
    // console.log(e);
    let str = "";
    const { all_team } = this.state;
    if (all_team.length > 0) {
      all_team.forEach((a) => {
        if (a.teamno === e) {
          str = a.teamname;
        }
      });
      this.setState({
        selectActionDuiwuName: str,
      });
    }
  };

  /**
   * 城市的队伍列表
   **/
  cityData = (e) => {
    if (Object.keys(this.state.teamList)[0]) {
      this.props.form.setFieldsValue({
        panelTab3: "",
      });
      this.setData({ playerList: [] });
    }
    if (e !== "") {
      this.setData(async () => {
        const teamList = await command.teamData2(e);
        this.setData({
          teamList: teamList || {},
          loading: false,
          selectDuiyuanIndexnoData: [],
          selectDuiyuanNameData: [],
        });
      });
    } else {
      app.alert("请选择省份~", "warn", "50%");
    }
  };

  /**
   * 队员列表
   **/
  menberData = (e) => {
    // console.log(e);
    // console.log(this.state.playerList);
    // if (Object.keys(this.state.teamList)[0]) {
    //     this.setData({ playerList: [] });
    // }
    if (e !== "") {
      this.setData(async () => {
        const playerList = await command.playerData2(e);
        this.setData({
          playerList: playerList || {},
          loading: false,
          selectDuiyuanIndexnoData: [],
          selectDuiyuanNameData: [],
        });
      });
    } else {
      app.alert("请选择队伍~", "warn", "50%");
    }
  };

  // 选中一名队员
  // 规则：选中队员是同时选中该名队员的其他身份；队员选择可以多选
  selectDuiyuan = (p1) => {
    const {
      playerList,
      selectDuiyuanIndexnoData,
      selectDuiyuanNameData,
    } = this.state;
    const length = Object.keys(playerList).length;
    let duiyuanIndexno = selectDuiyuanIndexnoData;
    let duiyuanName = selectDuiyuanNameData;
    // console.log(length)
    // console.log(playerList)
    if (length > 0) {
      // console.log(playerList)
      let data = playerList;
      // console.log(data);
      // console.log(Object.keys(playerList)[1]);
      Object.keys(data).forEach((item, index1) => {
        let pInfo = data[item];
        Object.keys(pInfo).forEach((item2, index2) => {
          let sfInfo = pInfo[item2];
          if (
            sfInfo.length > 0 &&
            item2 !== "teamno" &&
            item2 !== "teamheader" &&
            item2 !== "administrator" &&
            item2 !== "province"
          ) {
            sfInfo.forEach((item3, index3) => {
              // console.log(p1);
              // console.log(item3.indexno)
              // console.log('队伍：' + item + ' 身份：' + item2 + ' 队员名字：' + item3.vname);
              // 选中改变字段staus true则添加样式 false则去掉样式
              if (p1 === item3.bsrno) {
                // console.log('队伍：' + item + ' 身份：' + item2 + ' 队员名字：' + item3.vname);
                // status字段需要后端返回，如果返回了就没问题，没返回就要返回
                if (item3.status) {
                  item3.status = false;
                  duiyuanIndexno.forEach((e, i) => {
                    if (e === item3.indexno) {
                      duiyuanIndexno.splice(i, 1);
                    }
                  });
                  duiyuanName.forEach((e, i) => {
                    if (e === item3.vname) {
                      duiyuanName.splice(i, 1);
                    }
                  });
                } else {
                  item3.status = true;
                  duiyuanIndexno.push(item3.indexno);
                  duiyuanName.push(item3.vname);
                }
              }
            });
          }
        });
      });
      // 去重
      duiyuanIndexno = this.isRepeat(duiyuanIndexno);
      duiyuanName = this.isRepeat(duiyuanName);
      // console.log(duiyuanName)
      this.setData({
        selectDuiyuanIndexnoData: duiyuanIndexno,
        selectDuiyuanNameData: duiyuanName,
        playerList: data,
      });
    }

    // console.log(player, sf, p1);
  };

  // 选择操作（加入or转出）
  setAction1 = (e) => {
    if (e !== "") {
      // console.log(e);
      this.setState({
        action1: e,
      });
    }
  };

  /**
   * 设置值
   * @param data
   * @param cb
   */
  setData = (data, cb) => {
    if (this._isMounted) {
      this.setState(data, () => {
        if (cb) cb();
      });
    }
  };

  /**
   * 上一步
   */
  handlePrev = () => {
    let { panel_tab } = this.state;
    panel_tab--;
    const data = { panel_tab };
    switch (panel_tab) {
      case 1:
        data.reqParams = {};
        data.provinceList = [];
        break;
      case 2:
        data.teamList = [];
        break;
      case 3:
        data.playerList = [];
        break;
      default:
        console.log(666);
    }
    this.setData(data);
  };

  /**
   * 下一步
   */
  handleNext = () => {
    const { getFieldValue, validateFields } = this.props.form;
    let { panel_tab } = this.state;
    panel_tab++;
    const data = { panel_tab, loading: true };
    switch (panel_tab) {
      // 如果是省份，就加载省份接口
      // case 2:
      //     validateFields((err, values) => {
      //         if (!err) {
      //             data.reqParams = values;
      //             this.setData(data, async () => {
      //                 const provinceList = await command.provinceData();
      //                 this.setData({ provinceList, loading: false });
      //             });
      //         }
      //     });
      //     break;
      // case 3:
      //     const proviceSel = getFieldValue("panelTab2");
      //     if (checkField(proviceSel, "请选择省份~")) {
      //         this.setData(data, async () => {
      //             const teamList = await command.teamData2(proviceSel);
      //             this.setData({ teamList: teamList || {}, loading: false });
      //         });
      //     }
      //     break;
      // case 4:
      //     const teamSel = getFieldValue("panelTab3");
      //     if (checkField(teamSel, "请选择队伍~")) {
      //         const { reqParams } = this.state;
      //         reqParams.original_teamno = teamSel;
      //         data.reqParams = reqParams;
      //         this.setData(data, async () => {
      //             const playerList = await command.playerData2(teamSel);
      //             this.setData({ playerList: playerList || {}, loading: false });
      //         });
      //     }
      //     break;
      default:
        console.log(666);
    }
  };

  /**
   * 提交表单
   */
  handleSubmit = () => {
    const { submit_loading, selectDuiyuanIndexnoData } = this.state;
    const { getFieldValue } = this.props.form;
    let action = getFieldValue("type");
    let team = getFieldValue("current_teamno"); // 转入or加入现队伍编号
    //let provin = getFieldValue("panelTab2");
    let cityTeam = getFieldValue("panelTab3");
    let reason = getFieldValue("reason");
    // console.log('操作行为：' + action, '  操作队伍：' + team, '  省份：' + provin, '  队伍：' + cityTeam + ' 原因：' + reason)
    if (!checkField(action, "请选择操作状态~")) {
      return;
    }
    if (!checkField(team, "请选择队伍~")) {
      return;
    }
    // if (!checkField(provin, "请选择省份~")) {
    //   return;
    // }
    if (!checkField(cityTeam, "请选择队伍~")) {
      return;
    }
    if (team == cityTeam) {
      app.alert("队伍相同无法操作~", "warn", "50%");
      return;
    }
    if (selectDuiyuanIndexnoData === "") {
      app.alert("请选择队员~", "warn", "50%");
      return;
    }
    if (!checkField(reason, "请填写原因~")) {
      return;
    }
    // checkField(team, "请选择队伍~");
    // checkField(provin, "请选择省份~");
    // checkField(cityTeam, "请选择队伍~");
    if (submit_loading) return;
    const reqParamsData0 = this.state.reqParams;
    let reqParamsData1 = {
      ...reqParamsData0,
      indexno_object: selectDuiyuanIndexnoData.join(","), // 操作对象indexno(多个逗号隔开)
      type: action, // 操作：转入or加入
      original_teamno: cityTeam, // 原队伍编号
      current_teamno: team, // 转入现队伍编号
      reason: reason, // 转队原因
    };
    this.setData({ submit_loading: true }, async () => {
      const param = Object.assign(
        {
          indexno: app.getData("indexno"),
          account: app.getData("account"),
        },
        reqParamsData1
      );
      let { flag, msg } = await app.post(api.JoinTeam, param);
      if (flag === 1) {
        app.alert("提交成功", "success");
        this.props.form.resetFields();
        this.setData({
          reqParams: {},
          playerList: [],
          submit_loading: false,
          panel_tab: 1,
          action1: "1",
          teamList: [],
          selectDuiyuanIndexnoData: [],
          selectDuiyuanNameData: [],
        });
      } else {
        app.alert(msg, "warn");
      }
      this.setData({ submit_loading: false });
    });
  };

  /**
   * 取消
   */
  handleCancel = () => {
    this.props.form.resetFields();
    this.setData({ reqParams: {}, submit_loading: false, panel_tab: 1 });
  };

  /**
   * 树形选择
   * @param e
   * @param type
   */
  handleTreeSel = (e) => {
    let user = [];
    e.forEach((c) => {
      let arr = c.split("-ltjy-");
      if (arr.length === 3) {
        user.push(arr[2]);
      }
    });
    const { reqParams } = this.state;
    reqParams.indexno_object = user.join(",");
    this.setState({ reqParams });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form,
      {
        panel_tab,
        duiyuanColloct,
        action1,
        selectDuiyuanNameData,
        selectActionDuiwuName,
        reqParams,
        provinceList,
        loading,
        teamList,
        playerList,
        submit_loading,
        all_team,
        team_loading,
      } = this.state;
    // const teamKey = Object.keys(teamList)[0];
    const teamKey = Object.keys(teamList)[0];
    return (
      <div className="change-team">
        {loading ? (
          <div className="panel_loading">
            <Spin size="large" />
          </div>
        ) : (
          <Form style={{ height: "100vh", backgroundColor: "#fff" }}>
            <div
              className="redioItems"
              style={{ padding: "0 10%" }}
              // hidden={panel_tab !== 1}
            >
              <Row>
                <Col span={12}>
                  <FormItem
                    label={
                      <div
                        style={{
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                      >
                        {!getFieldValue("type")
                          ? "操作状态"
                          : getFieldValue("type") === "1"
                          ? "操作状态（从A队转到B队，系统重新生成新的存心编号）"
                          : getFieldValue("type") === "2"
                          ? "操作状态（从A队加入到B队，队员同时属于A队和B队，存心编号不变）"
                          : ""}
                      </div>
                    }
                    // label='操作状态（从A队转到B队，系统重新生成新的存心编号）'
                  >
                    {getFieldDecorator("type", {
                      rules: [{ required: true, message: "请选择操作状态" }],
                      initialValue: '1'
                    })(
                      <Select
                        size="large"
                        placeholder="请选择操作状态"
                        style={{ width: 450 }}
                        onChange={(e) => this.setAction1(e)}
                      >
                        <Option value="1">转入</Option>
                        {/*<Option value="2">加入</Option>*/}
                      </Select>
                    )}
                  </FormItem>
                  <FormItem
                    label={
                      <div
                        style={{
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                      >
                        {!getFieldValue("type")
                          ? "队伍"
                          : getFieldValue("type") === "1"
                          ? "转入队伍（需要转入的队伍）"
                          : getFieldValue("type") === "2"
                          ? "加入队伍（需要加入的队伍）"
                          : ""}
                      </div>
                    }
                  >
                    {getFieldDecorator("current_teamno", {
                      rules: [{ required: true, message: "请选择队伍" }],
                    })(
                      <Select
                        size="large"
                        placeholder="请选择队伍"
                        style={{ width: 450 }}
                        optionFilterProp="children"
                        notFoundContent={
                          team_loading ? "正在加载..." : "无记录"
                        }
                        showSearch
                        onChange={(e) => this.setCurrent_teamno(e)}
                      >
                        {all_team.map((team, index) => (
                          <Option key={index} value={team.teamno}>
                            {team.teamname}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                  {/*<FormItem*/}
                  {/*  label={*/}
                  {/*    <div*/}
                  {/*      style={{*/}
                  {/*        fontWeight: "600",*/}
                  {/*        display: "inline-block",*/}
                  {/*      }}*/}
                  {/*    >*/}
                  {/*      省份选择（选择队员所在省份）*/}
                  {/*    </div>*/}
                  {/*  }*/}
                  {/*>*/}
                  {/*  {getFieldDecorator("panelTab2", {*/}
                  {/*    rules: [{ required: true, message: "请选择省份" }],*/}
                  {/*  })(*/}
                  {/*    <Select*/}
                  {/*      size="large"*/}
                  {/*      placeholder="请选择省份"*/}
                  {/*      style={{ width: 450 }}*/}
                  {/*      optionFilterProp="children"*/}
                  {/*      notFoundContent={*/}
                  {/*        team_loading ? "正在加载..." : "无记录"*/}
                  {/*      }*/}
                  {/*      showSearch*/}
                  {/*      onChange={(e) => this.cityData(e)}*/}
                  {/*    >*/}
                  {/*      {provinceList.map((team, index) => (*/}
                  {/*        <Option key={index} value={team.area_name}>*/}
                  {/*          {team.area_name}*/}
                  {/*        </Option>*/}
                  {/*      ))}*/}
                  {/*    </Select>*/}
                  {/*  )}*/}
                  {/*</FormItem>*/}
                  <FormItem
                    label={
                      <div
                        style={{
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                      >
                        队伍选择（选择队员所在队伍）
                      </div>
                    }
                  >
                    {getFieldDecorator("panelTab3", {
                      rules: [{ required: true, message: "请选择队伍" }],
                    })(
                      <Select
                        size="large"
                        placeholder="请选择队伍"
                        style={{ width: 450 }}
                        optionFilterProp="children"
                        notFoundContent={
                          team_loading ? "正在加载..." : "无记录"
                        }
                        showSearch
                        onChange={(e) => this.menberData(e)}
                      >
                        {teamList.map((team, index) => (
                            <Option key={index} value={team.teamno}>
                              {team.teamname}
                            </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label={
                      <div
                        style={{
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                      >
                        {(getFieldValue("type") === "1"
                          ? "转入"
                          : getFieldValue("type") === "2"
                          ? "加入"
                          : "") + "原因"}
                      </div>
                    }
                  >
                    {getFieldDecorator("reason", {
                      rules: [
                        {
                          required: true,
                          message:
                            getFieldValue("type") === "1"
                              ? "请填写转队原因"
                              : getFieldValue("type") === "2"
                              ? "请填写加入原因"
                              : "请填写原因",
                        },
                      ],
                    })(
                      <Input.TextArea
                        placeholder={
                          getFieldValue("type") === "1"
                            ? "请填写转队原因"
                            : getFieldValue("type") === "2"
                            ? "请填写加入原因"
                            : "请填写原因"
                        }
                        rows={4}
                      />
                    )}
                  </FormItem>

                  {selectDuiyuanNameData.length > 0 ? (
                    <div style={{ marginBottom: 16 }}>
                      <span>操作提示：</span>
                      <span style={{ color: "#07c160", marginRight: 5 }}>
                        {selectDuiyuanNameData.join("、")}
                      </span>
                      从【
                      {Object.keys(playerList)[0] === ""
                        ? "-未选择队伍-"
                        : Object.keys(playerList)[0]}
                      】
                      {action1 === "1"
                        ? "转入"
                        : action1 === "2"
                        ? "加入"
                        : "-未选择操作状态-"}
                      【
                      {selectActionDuiwuName === ""
                        ? "-未选择队伍-"
                        : selectActionDuiwuName}
                      】
                    </div>
                  ) : null}
                  {/* {JSON.stringify(reqParams)} */}
                  <Button
                    onClick={() => this.handleSubmit()}
                    type="primary"
                    loading={submit_loading}
                  >
                    提交申请
                  </Button>
                </Col>
                <Col span={24}>
                  {Object.keys(playerList)[0] ? (
                    <FormItem
                      colon={false}
                      style={{
                        height: 40,
                      }}
                      label={
                        <div
                          style={{
                            width: 450,
                            height: 40,
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span>
                            <span style={{ color: "red" }}>*</span>{" "}
                            选择队员（队员可多选）
                            <span style={{ fontWeight: "400" }}>:</span>
                          </span>
                          <Select
                            style={{ width: 220 }}
                            showSearch
                            onChange={(e) => this.selectDuiyuan(e)}
                            placeholder="输入存心编号可搜索"
                            allowClear
                          >
                            {Object.keys(playerList).map((player) => {
                              let pInfo = playerList[player];
                              return Object.keys(pInfo).map((sf) => {
                                let sfInfo = pInfo[sf];
                                return sfInfo.length > 0 &&
                                  sf !== "teamno" &&
                                  sf !== "teamheader" &&
                                  sf !== "administrator" &&
                                  sf !== "province"
                                  ? sfInfo.map((p1) => {
                                      return (
                                        <Option key={p1.bsrno} value={p1.bsrno}>
                                          {p1.vname}
                                          {p1.bsrno !== undefined
                                            ? `(${p1.bsrno})`
                                            : ""}
                                        </Option>
                                      );
                                    })
                                  : null;
                              });
                            })}
                          </Select>
                        </div>
                      }
                    >
                      {getFieldDecorator("note", {
                        rules: [{ required: false, message: "请选择队员~" }],
                      })(
                        <div>
                          {Object.keys(playerList).map((player) => {
                            let pInfo = playerList[player];
                            return (
                              <div key={player}>
                                {Object.keys(pInfo).map((sf) => {
                                  let sfInfo = pInfo[sf];
                                  return sfInfo.length > 0 &&
                                    sf !== "teamno" &&
                                    sf !== "teamheader" &&
                                    sf !== "administrator" &&
                                    sf !== "province" ? (
                                    <div
                                      className="npoo"
                                      // title={command.checkSF(sf)}
                                      // style={styles.npoo}
                                      key={`${player}-ltjy-${sf}`}
                                    >
                                      <div
                                        style={{
                                          display: "inline-block",
                                          minWidth: 80,
                                          marginLeft: 10,
                                        }}
                                      >
                                        {command.checkSF(sf)}：
                                      </div>
                                      <div style={{ display: "inline-block" }}>
                                        {sfInfo.map((p1) => {
                                          return (
                                            <div
                                              className={
                                                p1.status ? "npc npco" : "npc"
                                              }
                                              // style={styles.npc}
                                              onClick={() =>
                                                this.selectDuiyuan(p1.bsrno)
                                              }
                                              key={`${pInfo.province}-ltjy-${pInfo.teamno}-ltjy-${p1.indexno}`}
                                            >
                                              {p1.vname}
                                              {p1.bsrno
                                                ? `(${p1.bsrno})`
                                                : null}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  ) : null;
                                })}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </FormItem>
                  ) : null}
                </Col>
              </Row>
            </div>
            {/* <div
                                // hidden={panel_tab !== 2}
                                className="redioItems"
                            >
                            <div className="panel_title">省份选择</div>
                            <FormItem className="redioItem">
                                {getFieldDecorator('panelTab2')(
                                    <RadioGroup>
                                        {
                                            provinceList.map((pro, index) =>
                                                <Radio className="no-select" key={index}
                                                    value={pro.area_name}>{pro.area_name}</Radio>
                                            )
                                        }
                                    </RadioGroup>
                                )}
                            </FormItem>
                            </div> */}
            {/* <div hidden={panel_tab !== 3} className="redioItems">
                                <div className="panel_title">队伍选择（{teamKey}）</div>
                                <FormItem className="redioItem">
                                    {getFieldDecorator('panelTab3')(
                                        <RadioGroup>
                                            {
                                                teamKey ? teamList[teamKey].map((team, index) =>
                                                    <Radio className="no-select" key={index}
                                                        value={team.teamno}>{team.teamname}</Radio>
                                                ) : null
                                            }
                                        </RadioGroup>
                                    )}
                                </FormItem>
                            </div>  */}
            {/* <div hidden={panel_tab !== 4} className="redioItems">
                                <div className="panel_title">队员选择（{teamKey}）</div>
                                <Tree
                                    className="redioItem"
                                    checkable
                                    onCheck={(e) => this.handleTreeSel(e)}
                                >
                                    <TreeNode title="所有队员" key="0">
                                        {
                                            Object.keys(playerList).map((player) => {
                                                let pInfo = playerList[player];
                                                return (
                                                    <TreeNode title={player} key={player}>
                                                        {
                                                            Object.keys(pInfo).map((sf) => {
                                                                let sfInfo = pInfo[sf];
                                                                return sfInfo.length > 0 && sf !== "teamno" && sf !== "province" ? (
                                                                    <TreeNode
                                                                        title={command.checkSF(sf)}
                                                                        key={`${player}-ltjy-${sf}`}>
                                                                        {sfInfo.map((p1) => {
                                                                            return (
                                                                                <TreeNode
                                                                                    title={p1.vname}
                                                                                    key={`${pInfo.province}-ltjy-${pInfo.teamno}-ltjy-${p1.indexno}`}
                                                                                />
                                                                            )
                                                                        })}
                                                                    </TreeNode>
                                                                ) : null
                                                            })
                                                        }
                                                    </TreeNode>
                                                )
                                            })
                                        }
                                    </TreeNode>
                                </Tree>
                            </div> */}
          </Form>
        )}
        {/* <div className="btns">
                    {panel_tab === 4 ? (
                        <Button onClick={() => this.handleSubmit()} type="primary"
                            loading={submit_loading}>提交申请</Button>) : null}
                    {panel_tab > 1 ? (<Button onClick={() => this.handlePrev()}>上一步</Button>) : null}
                    {panel_tab < 4 ? (<Button onClick={() => this.handleNext()}>下一步</Button>) : null}
                    <Button onClick={() => this.handleCancel()}>取消</Button>                
                </div> */}
      </div>
    );
  }
}

ChangeTeam.propTypes = {
  team_id: PropTypes.string.isRequired,
};

// const styles = {
//     // npoo: {
//     //     fontWeight: 600,
//     // },
//     npc: {
// fontWeight: 450,
// display: 'inline-block',
// borderWidth: 1,
// borderColor: '#f2f2f2',
// paddingLeft: 20,
// paddingRight: 20,

//     }
// }

export default Form.create()(ChangeTeam);



// WEBPACK FOOTER //
// ./src/routes/ranks/ChangeTeam.jsx